import { render, staticRenderFns } from "./CardGeneralIndex.vue?vue&type=template&id=ff5d2092&scoped=true&"
import script from "./CardGeneralIndex.vue?vue&type=script&lang=js&"
export * from "./CardGeneralIndex.vue?vue&type=script&lang=js&"
import style0 from "./CardGeneralIndex.vue?vue&type=style&index=0&id=ff5d2092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5d2092",
  null
  
)

export default component.exports